import { useState } from "react";
import { Style } from './style';
import MainCont from "./components/MainCont";
import IconCont from "./components/IconCont";

export default function Alert({ message = '', localKey = '' }) {
  const [visible, setVisible] = useState(
    !localStorage.getItem(localKey)
  );
  const [mainInitVisible, setMainInitVisible] = useState(visible);
  const [iconInitVisible, setIconInitVisible] = useState(visible);

  const onClick = () => {
    if (visible) {
      setVisible(false);
      localStorage.setItem(localKey, 'closed');
    } else {
      setVisible(true);
      localStorage.removeItem(localKey);
    }
  };

  return (
    <Style>
      {visible ? (
        <MainCont
          message={message}
          onClick={onClick}
          initVisible={mainInitVisible}
          setInitVisible={setMainInitVisible}
        />
      ) : (
        <IconCont
          onClick={onClick}
          initVisible={iconInitVisible}
          setInitVisible={setIconInitVisible}
        />
      )}
    </Style >
  );
}
